import { createColumn, defaultColumns, inputTextField, relationField, booleanComponent } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Question',
    field: 'questionId',
    section: '',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'questionId',
      fk: 'id',
      namespace: 'question',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Hidden',
    field: 'hidden',
    section: '',
    defaultValue: false,
    type: 'boolean',
    component: booleanComponent
  }),
  createColumn({
    label: 'Option',
    field: 'optionText',
    section: '',
    component: inputTextField({ type: 'text', req: true, max: 255 })
  }),
  createColumn({
    label: 'Option Value',
    field: 'optionValue',
    section: '',
    component: inputTextField({ type: 'text', req: false, max: 255 })
  }),
  createColumn({
    label: 'Cost Modifier',
    field: 'costModifier',
    section: '',
    component: inputTextField({ type: 'number', req: false, max: 10, money: true })
  }),
  createColumn({
    label: 'Sort',
    field: 'sort',
    section: '',
    component: inputTextField({ type: 'number', req: false, max: 4 })
  })
].concat(defaultColumns)
